var map = {
	"./stage1.png": "ebd5",
	"./stage1_large.png": "b2b0",
	"./stage2.png": "1506",
	"./stage2_large.png": "c079",
	"./stage3.png": "d72d",
	"./stage3_large.png": "857a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1af4";